import {
    useContext,
} from 'react';

import {
    Card,
    CardContent,
    CardHeader,
} from '@mui/material';

import { Trans } from 'react-i18next';

import {
    setUser,
} from '../../context/actions';
import { Context } from '../../context/context';
import EditWorkTimeModelTable from '../shared/EditWorkTimeModelTable';

import api from '../../api';

function EditWorkTimeModel() {
    const [{ user }, dispatch] = useContext(Context);

    const handleChange = (user) => {
        api.updateUser(user.id, user).then(res => {
            dispatch(setUser(res));
        })
    };

    return (
        <>
            <Card sx={{ overflowY: 'auto', width: '100vw', p: 3 }}>
                <CardHeader title={<Trans i18nKey='arbeitszeitmodell' ns='userSettingsPage'>Arbeitszeitmodell</Trans>} />
                <CardContent sx={{ width: '75%' }}>
                    <EditWorkTimeModelTable user={user} onChange={handleChange} />
                </CardContent>
            </Card>
        </>
    );
};

export default EditWorkTimeModel;
